import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import styles from './index.module.sass';

//Dependencies
import superagent from 'superagent';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Alert from '../Alert';

//Custom
//import deptosArray from './ProductForm/deptos.js';
//import subDeptosArray from './ProductForm/subdeptos.js';
//import deptosArrayMX from './ProductForm/deptosMX.js';
//import subDeptosArrayMX from './ProductForm/subdeptosMX.js';

// const deptosArr = (process.env.REACT_APP_COUNTRY === 'MX' && deptosArrayMX) || deptosArray;
// const subDeptosArr = (process.env.REACT_APP_COUNTRY === 'MX' && subDeptosArrayMX) || subDeptosArray;

const Product = (props) => {
  const { webserviceURL, setSectionName, setOptionSelected, match } = props;
  const [productList, setProductList] = useState([]);
  const [deptoSelected, setDeptoSelected] = useState('1');
  const [loading, setLoading] = useState(false);
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);

  const [categorias, setCategorias] = useState([]);

  const getProducts = useCallback(() => {
    const url = `${webserviceURL}/getDescripciones?depto=0&subdepto=&clave=`;
    setLoading(true);
    superagent
      .get(url)
      .set('Content-Type', 'application/json')
      .auth(localStorage.getItem('TMBtoken'), { type: 'bearer' })
      .set('token', localStorage.getItem('TMBtoken'))
      .then((res) => {
        if (res.body) {
          setProductList(res.body);
        } else {
          setAlertText('Ocurrió un error');
          setOpen(true);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [webserviceURL]);

  const deleteProduct = (product) => {
    setLoading(true);
    let question = window.confirm('¿Eliminar producto? Esta acción no se puede deshacer');
    if (question) {
      const url = `${webserviceURL}/postDescripciones`;

      superagent
        .post(url)
        .set('Content-Type', 'application/json')
        .auth(localStorage.getItem('TMBtoken'), { type: 'bearer' })
        .send({
          ...product,
          accion: 'BORRAR',
        })
        .then((res) => {
          if (res.body) {
            const { mensaje } = res.body;
            window.scrollTo(0, 0);
            setAlertText(mensaje);
            setOpen(true);
            getProducts();
          } else {
            setAlertText('Ocurró un error, vuelva a intentarlo');
            setOpen(true);
          }
        })
        .catch((err) => {
          console.log(err);
          setAlertText('Ocurró un error');
          setOpen(true);
        });
    } else {
      setLoading(false);
    }
  };

  // Estas categorias son las mismas que tiene el carrito
  const getCategorias = useCallback(() => {
    const urlCategorias = `${webserviceURL}/getDeptos`;
    superagent
      .get(urlCategorias)
      .set('Content-Type', 'application/json')
      .auth(localStorage.getItem('TMBtoken'), { type: 'bearer' })
      .then((res) => {
        if (res.body) {
          const categorias = res.body.filter((item) => item.menu === '3');
          setCategorias(categorias);
        } else {
          setAlertText('Ocurró un error al cargar las categorias, vuelva a intentarlo');
          setOpen(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setAlertText('Ocurró un error al cargar las categorias');
      });
  }, [webserviceURL]);

  useEffect(() => {
    getProducts();
    setSectionName('Productos');
    setOptionSelected('products');
    getCategorias();
  }, [getProducts, setSectionName, setOptionSelected, getCategorias]);

  const obtenerNombreSubdepto = (
    categorias: any[],
    deptoSelected: string,
    subdepartamento: string,
  ): string => {
    const depto = categorias.find((item) => item.depto === deptoSelected && item.menu === '3');

    if (!depto) return '';
    const sub = depto.secciones.find((sec) => sec.subdepto === subdepartamento);
    return sub?.nombre ?? '';
  };

  return (
    <div className={styles.productListContainer}>
      <Alert open={open} setOpen={setOpen} title='Mensaje del sistema' text={alertText} />
      <div className={styles.buttonNewProduct}>
        <Link to={`${match.path}/editproduct/newproduct`}>
          <Button
            type='button'
            variant='contained'
            size='large'
            color='primary'
            className={`${styles.button}`}>
            Nuevo producto
          </Button>
        </Link>
      </div>
      <div className={styles.tabs}>
        {categorias.map((val, key) => {
          return (
            <div className={styles.tab} key={key}>
              <div
                className={`${styles.tabContent} ${styles[deptoSelected === val.depto]}`}
                onClick={() => setDeptoSelected(val.depto)}>
                {val.nombre}
              </div>
            </div>
          );
        })}
      </div>
      {loading && (
        <div className={styles.loading}>
          <CircularProgress />
        </div>
      )}
      {productList.length > 0 && (
        <div className={styles.productList}>
          <div className={`${styles.productRow} ${styles.header}`}>
            <div className={`${styles.headerColumn} ${styles.imageProduct}`}>Imagen</div>
            <div className={`${styles.headerColumn}`}>Clave</div>
            <div className={`${styles.headerColumn}`}>Nombre</div>
            <div className={`${styles.headerColumn}`}>Departamento</div>
            <div className={`${styles.headerActions}`}>Acciones</div>
          </div>
          {productList.map((val, key) => {
            const rowType = key % 2;
            const { clave, producto, departamento, subdepartamento } = val;

            const subdepto = obtenerNombreSubdepto(categorias, deptoSelected, subdepartamento);

            return (
              deptoSelected === departamento && (
                <div className={`${styles.productRow} ${styles[rowType]}`} key={key}>
                  <div className={`${styles.productColumn} ${styles.imageProduct}`}>
                    <img
                      src={`https://webimages.terramarbrands.com.mx/shopping-cart/cart-products/${clave}.jpg`}
                      alt=''
                    />
                  </div>
                  <div className={`${styles.productColumn}`}>{clave}</div>
                  <div className={`${styles.productColumn}`}>{producto}</div>
                  <div className={`${styles.productColumn}`}>{subdepto}</div>
                  <div className={styles.actions}>
                    <div className={`${styles.action} ${styles.edit}`}>
                      <Link to={`${match.path}/editproduct/${clave}`} className={styles.edit}>
                        <i className='material-icons'>edit</i>
                      </Link>
                    </div>
                    <div
                      className={`${styles.action} ${styles.delete}`}
                      onClick={() => deleteProduct(val)}>
                      <i className='material-icons'>delete</i>
                    </div>
                  </div>
                </div>
              )
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Product;
